// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 992px) { /*desktop */
   .container {
      align-items: center;
      margin: 40px auto;
      width: 1000px;
   }

   .status {
      border-radius: 3px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 8px 12px;
      position: relative;
      width: 150px;
      transition: all .2s ease;
   }

   .signature {
      background-color: #fff;
      border: 2px dashed #ccc;
      border-radius: 10px;
      cursor: pointer;
      margin-top: 4px;
      margin-left: 10px;
      width: 260px;
      height: 70px;
   }
   .signature img {
      max-height: 50px;
      max-width: 220px;
   }

   .initials {
      background-color: #fff;
      border: 2px dashed #ccc;
      border-radius: 10px;
      cursor: pointer;
      margin-top: 4px;
      margin-left: 25px;
      width: 200px;
      height: 70px;
   }
   .initials img {
      object-fit: contain;
      max-height: 50px;
      max-width: 220px;
   }
   .signature-label {
      margin-left: 10px;
   }

   .init-label {
      margin-left: 25px;
   }

   .status + .status {
      margin-left: 20px;
   }
   .status + .status::before {
      background: rgba(0,0,0,.1);
      bottom: 0;
      content: '';
      display: block;
      left: -12px;
      margin: 8px 0;
      position: absolute;
      top: 0;
      width: 1px;
   }

   .actions {
      background-color: #fcfcfc;
      border: 1px solid #e5e5e5;
      margin: 30px 0;
      padding: 40px;
   }

   .etax {
      background-color: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 6px;
      cursor: pointer;
      font-size: 16px;
      display: inline-block;
      margin: 10px auto 30px;
      padding: 5px 50px;
   }

   .company {
      border-bottom: 2px solid #2AB4C0;
      font-size: 22px;
      line-height: normal;
      margin-right: 30px;
      width: 440px;
   }

   .space {
      background-color: #d4f0f2;
      color: #007c9e;
      float: right;
      padding: 10px 15px 15px;
   }

   .money-chart {
      padding: 25px 20px ;
      position: relative;
      width: 440px;
      height: 340px;
      overflow: hidden;
      text-align: center;
   }

   .card {
      background: #fff;
      box-shadow: 0 1px 4px rgba(0,0,0,.1);
      padding: 10px;
   }

   .type-chart {
      padding: 10px 30px 20px;
      position: relative;
      width: 330px;
      height: 340px;
      overflow: hidden;
   }

   .usage-chart {
      padding: 1em;
      position: relative;
      width: 800px;
   }
}

@media (min-width: 0px) and (max-width: 992px) { /*mobile */
   .container {
      align-items: center;
      padding: 5px;
   }

   .signature {
      background-color: #fff;
      border: 2px dashed #ccc;
      border-radius: 10px;
      cursor: pointer;
      margin: 4px 4px;
      height: 100px;
   }
   .signature img {
      max-height: 90px;
   }

   .initials {
      background-color: #fff;
      border: 2px dashed #ccc;
      border-radius: 10px;
      cursor: pointer;
      margin: 4px 4px;
      height: 100px;
   }
   .initials img {
      max-height: 90px;
   }

   .status {
      border-radius: 10px;
      border: 2px solid #ccc;
      cursor: pointer;
      flex-direction: column;
      padding: 8px 12px;
      margin: 4px 4px;
      transition: all .2s ease;
   }

   .data-status{
      padding-left: 50px;
   }

   .file-icon img {
      margin: auto;
      display: block;
      padding: 5px;
      width: 64px;
      object-fit: contain;
   }

   .actions {
      background-color: #fcfcfc;
      border: 1px solid #e5e5e5;
      margin: 5px 0;
      padding: 40px 0 40px 0;
   }

   .menu-button{
      padding: 1px 6px 1px 6px;
   }

   .etax {
      background-color: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 6px;
      cursor: pointer;
      font-size: 16px;
      display: inline-block;
      margin: 10px auto 10px;
      padding: 5px 50px;
      width: 100%;
   }

   .company {
      border-bottom: 2px solid #2AB4C0;
      font-size: 22px;
      line-height: normal;
      width: 100%;
      margin: 5px 0;
   }

   .space {
      width: 100%;
      background-color: #d4f0f2;
      color: #007c9e;
      float: right;
      padding: 10px 15px 15px;
      margin-top: 10px;
   }

   .money-chart {
      padding: 25px 20px ;
      position: relative;
      width: 100%;
      height: 340px;
      overflow: hidden;
      text-align: center;
   }

   .card {
      background: #fff;
      box-shadow: 0 1px 4px rgba(0,0,0,.1);
      padding: 10px;
   }

   .type-chart {
      padding: 10px 30px 20px;
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
   }

   .usage-chart {
      position: relative;
      width: 100%;
   }
}

.status:hover {
   background-color: rgba(0,0,0,.05);
   color: #000;
   text-decoration: none;
}

.status .counter {
   font-size: 36px;
}

.actions button {
   border: 1px solid #2AB4C0;
   background-color: #fff;
}
.actions button + button {
   margin-left: 2em;
}
.actions img, .actions svg {
   height: 20px;
   margin-right: 8px;
   width: 20px;
}
.actions img, .actions span {
   display: inline-block;
   vertical-align: middle;
}
.sign-now-button{
   margin-left: 10px!important;
}

.box+.box {
   margin-top: 30px;
}

.etax img {
   display: block;
   height: 75px;
   width: 80px;
   margin: 10px auto;
   -webkit-user-select: none;
           user-select: none;
}
.quota {
   background-color: rgba(255,255,255,.5);
   margin-top: 8px;
   width: 300px;
}
.used {
   background-color: #2AB4C0;
   width: 0;
   height: 10px;
   transition: width 1s ease-in;
}
.usage {
   font-size: 12px;
}

.activities {
   min-height: 300px;
   padding: 10px 0 0 10px;
   position: relative;
   width: 800px;
}
h3 {
   margin: 10px;
   text-align: center;
}
#money {
   margin-bottom: 30px;
}
.money-chart .buy-button {
   background-color: #fff;
   border: 1px solid #2ab4c0;
   /*border-radius: 4px;*/
   /*cursor: pointer;*/
   /*display: inline-block;*/
   /*line-height: 36px;*/
   padding: 0 5px;
   width: 125px;
   /*user-select: none;*/
}
.money-chart button.sell {
   background-color: #fff;
   border: 1px solid #ffa726;
   width: 125px;
   padding: 0 5px;
}
.money-chart button + button {
   margin-left: 2em;
}
#usage {
   height: 386px;
}
.doclist {
   list-style: none;
   margin: 9px 0 0;
   padding: 0;
}
.doclist li {
   border-top: 1px solid transparent;
   margin-top: -1px;
   padding: 8px;
   position: relative;
}
.doclist li:not(:last-child) {
   border-bottom: 1px solid #eaeaea;
}
.avatar {
   border-radius: 50%;
   margin-right: 10px;
   object-fit: contain;
   width: 32px;
   height: 32px;
}
.name {
   color: #222;
}
.time {
   color: #999;
   font-size: 12px;
}
.list-activity {
   max-height: 300px;
   overflow-x: hidden;
   overflow-y: auto;
}
hr {
   border: 0;
   border-top: 1px solid #ccc;
   margin: 20px 0;
}
td {
   text-align: left;
   padding: 5px
}
td div {
   overflow-wrap: break-word;
   width: 250px;
}
.sum {
   font-size: 28px;
   margin-bottom: 10px;
}
.buy {
   color: #2ab4c0;
}
.sell {
   color: #ffa726;
}
.amount {
   width: 100%;
}
.amount td:first-child, .amount td:nth-child(2) {
   text-align: right;
   white-space: nowrap;
}
.amount td:nth-child(2) {
   width: 30%;
}
.center {
   text-align: center;
}

.grid-container-columns {
   display: grid;
   grid-row-gap: 0px;
   grid-template-columns: auto auto auto;
   /*background-color: #2196F3;*/
   /*padding: 10px;*/
}

.grid-container-rows{
   display: grid;
   grid-row-gap: 0px;
   grid-template-rows: auto auto auto;
}

.grid-item {
   /*background-color: rgba(255, 255, 255, 0.8);*/
   /*border: 1px solid rgba(0, 0, 0, 0.8);*/
   /*padding: 20px;*/
   /*font-size: 30px;*/
   /*text-align: center;*/
}
/*::ng-deep cdk-global-scrollblock {*/
   /*overflow-y: hidden!important;*/
/*}*/
.max-space{
   font-size:14px!important;
   margin-left: 110px;
   margin-bottom: 10px;
}
.link{
   cursor: default!important;
   font-size:10px;
   pointer-events: none;
   text-align: right;
   width: 90px;
}
.progress-bar{
   height:18px;
   border-radius: 15px;
   width:330px;
   pointer-events: none;
}
.progress-form{
   width:50%;
   margin-left: 15px;
   margin-right: 10px;
   padding: 20px 20px 10px 20px!important;
}
.type-name{
   width:80px;
}
.button-form{
   width:50% !important;
}
::ng-deep .mat-progress-bar-buffer {
   background: #E4E8EB!important;
}
.space-left{
   width:230px;
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/dashboard.component.css"],"names":[],"mappings":"AAAA,4BAA4B,WAAW;GACpC;MACG,mBAAmB;MACnB,iBAAiB;MACjB,aAAa;GAChB;;GAEA;MACG,kBAAkB;MAClB,eAAe;MACf,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,iBAAiB;MACjB,kBAAkB;MAClB,YAAY;MACZ,wBAAwB;GAC3B;;GAEA;MACG,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe;MACf,eAAe;MACf,iBAAiB;MACjB,YAAY;MACZ,YAAY;GACf;GACA;MACG,gBAAgB;MAChB,gBAAgB;GACnB;;GAEA;MACG,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe;MACf,eAAe;MACf,iBAAiB;MACjB,YAAY;MACZ,YAAY;GACf;GACA;MACG,mBAAmB;MACnB,gBAAgB;MAChB,gBAAgB;GACnB;GACA;MACG,iBAAiB;GACpB;;GAEA;MACG,iBAAiB;GACpB;;GAEA;MACG,iBAAiB;GACpB;GACA;MACG,0BAA0B;MAC1B,SAAS;MACT,WAAW;MACX,cAAc;MACd,WAAW;MACX,aAAa;MACb,kBAAkB;MAClB,MAAM;MACN,UAAU;GACb;;GAEA;MACG,yBAAyB;MACzB,yBAAyB;MACzB,cAAc;MACd,aAAa;GAChB;;GAEA;MACG,sBAAsB;MACtB,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;MACf,eAAe;MACf,qBAAqB;MACrB,sBAAsB;MACtB,iBAAiB;GACpB;;GAEA;MACG,gCAAgC;MAChC,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,YAAY;GACf;;GAEA;MACG,yBAAyB;MACzB,cAAc;MACd,YAAY;MACZ,uBAAuB;GAC1B;;GAEA;MACG,mBAAmB;MACnB,kBAAkB;MAClB,YAAY;MACZ,aAAa;MACb,gBAAgB;MAChB,kBAAkB;GACrB;;GAEA;MACG,gBAAgB;MAChB,oCAAoC;MACpC,aAAa;GAChB;;GAEA;MACG,uBAAuB;MACvB,kBAAkB;MAClB,YAAY;MACZ,aAAa;MACb,gBAAgB;GACnB;;GAEA;MACG,YAAY;MACZ,kBAAkB;MAClB,YAAY;GACf;AACH;;AAEA,iDAAiD,UAAU;GACxD;MACG,mBAAmB;MACnB,YAAY;GACf;;GAEA;MACG,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe;MACf,eAAe;MACf,aAAa;GAChB;GACA;MACG,gBAAgB;GACnB;;GAEA;MACG,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe;MACf,eAAe;MACf,aAAa;GAChB;GACA;MACG,gBAAgB;GACnB;;GAEA;MACG,mBAAmB;MACnB,sBAAsB;MACtB,eAAe;MACf,sBAAsB;MACtB,iBAAiB;MACjB,eAAe;MACf,wBAAwB;GAC3B;;GAEA;MACG,kBAAkB;GACrB;;GAEA;MACG,YAAY;MACZ,cAAc;MACd,YAAY;MACZ,WAAW;MACX,mBAAmB;GACtB;;GAEA;MACG,yBAAyB;MACzB,yBAAyB;MACzB,aAAa;MACb,sBAAsB;GACzB;;GAEA;MACG,wBAAwB;GAC3B;;GAEA;MACG,sBAAsB;MACtB,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;MACf,eAAe;MACf,qBAAqB;MACrB,sBAAsB;MACtB,iBAAiB;MACjB,WAAW;GACd;;GAEA;MACG,gCAAgC;MAChC,eAAe;MACf,mBAAmB;MACnB,WAAW;MACX,aAAa;GAChB;;GAEA;MACG,WAAW;MACX,yBAAyB;MACzB,cAAc;MACd,YAAY;MACZ,uBAAuB;MACvB,gBAAgB;GACnB;;GAEA;MACG,mBAAmB;MACnB,kBAAkB;MAClB,WAAW;MACX,aAAa;MACb,gBAAgB;MAChB,kBAAkB;GACrB;;GAEA;MACG,gBAAgB;MAChB,oCAAoC;MACpC,aAAa;GAChB;;GAEA;MACG,uBAAuB;MACvB,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,gBAAgB;GACnB;;GAEA;MACG,kBAAkB;MAClB,WAAW;GACd;AACH;;AAEA;GACG,iCAAiC;GACjC,WAAW;GACX,qBAAqB;AACxB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,yBAAyB;GACzB,sBAAsB;AACzB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,YAAY;GACZ,iBAAiB;GACjB,WAAW;AACd;AACA;GACG,qBAAqB;GACrB,sBAAsB;AACzB;AACA;GACG,2BAA2B;AAC9B;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,YAAY;GACZ,WAAW;GACX,iBAAiB;GACjB,yBAAiB;WAAjB,iBAAiB;AACpB;AACA;GACG,sCAAsC;GACtC,eAAe;GACf,YAAY;AACf;AACA;GACG,yBAAyB;GACzB,QAAQ;GACR,YAAY;GACZ,4BAA4B;AAC/B;AACA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;GACjB,sBAAsB;GACtB,kBAAkB;GAClB,YAAY;AACf;AACA;GACG,YAAY;GACZ,kBAAkB;AACrB;AACA;GACG,mBAAmB;AACtB;AACA;GACG,sBAAsB;GACtB,yBAAyB;GACzB,sBAAsB;GACtB,mBAAmB;GACnB,yBAAyB;GACzB,qBAAqB;GACrB,cAAc;GACd,YAAY;GACZ,qBAAqB;AACxB;AACA;GACG,sBAAsB;GACtB,yBAAyB;GACzB,YAAY;GACZ,cAAc;AACjB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,aAAa;AAChB;AACA;GACG,gBAAgB;GAChB,eAAe;GACf,UAAU;AACb;AACA;GACG,iCAAiC;GACjC,gBAAgB;GAChB,YAAY;GACZ,kBAAkB;AACrB;AACA;GACG,gCAAgC;AACnC;AACA;GACG,kBAAkB;GAClB,kBAAkB;GAClB,mBAAmB;GACnB,WAAW;GACX,YAAY;AACf;AACA;GACG,WAAW;AACd;AACA;GACG,WAAW;GACX,eAAe;AAClB;AACA;GACG,iBAAiB;GACjB,kBAAkB;GAClB,gBAAgB;AACnB;AACA;GACG,SAAS;GACT,0BAA0B;GAC1B,cAAc;AACjB;AACA;GACG,gBAAgB;GAChB;AACH;AACA;GACG,yBAAyB;GACzB,YAAY;AACf;AACA;GACG,eAAe;GACf,mBAAmB;AACtB;AACA;GACG,cAAc;AACjB;AACA;GACG,cAAc;AACjB;AACA;GACG,WAAW;AACd;AACA;GACG,iBAAiB;GACjB,mBAAmB;AACtB;AACA;GACG,UAAU;AACb;AACA;GACG,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,iBAAiB;GACjB,qCAAqC;GACrC,6BAA6B;GAC7B,iBAAiB;AACpB;;AAEA;GACG,aAAa;GACb,iBAAiB;GACjB,kCAAkC;AACrC;;AAEA;GACG,8CAA8C;GAC9C,wCAAwC;GACxC,iBAAiB;GACjB,mBAAmB;GACnB,sBAAsB;AACzB;AACA,qCAAqC;GAClC,gCAAgC;AACnC,IAAI;AACJ;GACG,wBAAwB;GACxB,kBAAkB;GAClB,mBAAmB;AACtB;AACA;GACG,yBAAyB;GACzB,cAAc;GACd,oBAAoB;GACpB,iBAAiB;GACjB,WAAW;AACd;AACA;GACG,WAAW;GACX,mBAAmB;GACnB,WAAW;GACX,oBAAoB;AACvB;AACA;GACG,SAAS;GACT,iBAAiB;GACjB,kBAAkB;GAClB,sCAAsC;AACzC;AACA;GACG,UAAU;AACb;AACA;GACG,oBAAoB;AACvB;AACA;GACG,6BAA6B;AAChC;AACA;GACG,WAAW;AACd","sourcesContent":["@media (min-width: 992px) { /*desktop */\n   .container {\n      align-items: center;\n      margin: 40px auto;\n      width: 1000px;\n   }\n\n   .status {\n      border-radius: 3px;\n      cursor: pointer;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      padding: 8px 12px;\n      position: relative;\n      width: 150px;\n      transition: all .2s ease;\n   }\n\n   .signature {\n      background-color: #fff;\n      border: 2px dashed #ccc;\n      border-radius: 10px;\n      cursor: pointer;\n      margin-top: 4px;\n      margin-left: 10px;\n      width: 260px;\n      height: 70px;\n   }\n   .signature img {\n      max-height: 50px;\n      max-width: 220px;\n   }\n\n   .initials {\n      background-color: #fff;\n      border: 2px dashed #ccc;\n      border-radius: 10px;\n      cursor: pointer;\n      margin-top: 4px;\n      margin-left: 25px;\n      width: 200px;\n      height: 70px;\n   }\n   .initials img {\n      object-fit: contain;\n      max-height: 50px;\n      max-width: 220px;\n   }\n   .signature-label {\n      margin-left: 10px;\n   }\n\n   .init-label {\n      margin-left: 25px;\n   }\n\n   .status + .status {\n      margin-left: 20px;\n   }\n   .status + .status::before {\n      background: rgba(0,0,0,.1);\n      bottom: 0;\n      content: '';\n      display: block;\n      left: -12px;\n      margin: 8px 0;\n      position: absolute;\n      top: 0;\n      width: 1px;\n   }\n\n   .actions {\n      background-color: #fcfcfc;\n      border: 1px solid #e5e5e5;\n      margin: 30px 0;\n      padding: 40px;\n   }\n\n   .etax {\n      background-color: #fff;\n      border: 1px solid #e5e5e5;\n      border-radius: 6px;\n      cursor: pointer;\n      font-size: 16px;\n      display: inline-block;\n      margin: 10px auto 30px;\n      padding: 5px 50px;\n   }\n\n   .company {\n      border-bottom: 2px solid #2AB4C0;\n      font-size: 22px;\n      line-height: normal;\n      margin-right: 30px;\n      width: 440px;\n   }\n\n   .space {\n      background-color: #d4f0f2;\n      color: #007c9e;\n      float: right;\n      padding: 10px 15px 15px;\n   }\n\n   .money-chart {\n      padding: 25px 20px ;\n      position: relative;\n      width: 440px;\n      height: 340px;\n      overflow: hidden;\n      text-align: center;\n   }\n\n   .card {\n      background: #fff;\n      box-shadow: 0 1px 4px rgba(0,0,0,.1);\n      padding: 10px;\n   }\n\n   .type-chart {\n      padding: 10px 30px 20px;\n      position: relative;\n      width: 330px;\n      height: 340px;\n      overflow: hidden;\n   }\n\n   .usage-chart {\n      padding: 1em;\n      position: relative;\n      width: 800px;\n   }\n}\n\n@media (min-width: 0px) and (max-width: 992px) { /*mobile */\n   .container {\n      align-items: center;\n      padding: 5px;\n   }\n\n   .signature {\n      background-color: #fff;\n      border: 2px dashed #ccc;\n      border-radius: 10px;\n      cursor: pointer;\n      margin: 4px 4px;\n      height: 100px;\n   }\n   .signature img {\n      max-height: 90px;\n   }\n\n   .initials {\n      background-color: #fff;\n      border: 2px dashed #ccc;\n      border-radius: 10px;\n      cursor: pointer;\n      margin: 4px 4px;\n      height: 100px;\n   }\n   .initials img {\n      max-height: 90px;\n   }\n\n   .status {\n      border-radius: 10px;\n      border: 2px solid #ccc;\n      cursor: pointer;\n      flex-direction: column;\n      padding: 8px 12px;\n      margin: 4px 4px;\n      transition: all .2s ease;\n   }\n\n   .data-status{\n      padding-left: 50px;\n   }\n\n   .file-icon img {\n      margin: auto;\n      display: block;\n      padding: 5px;\n      width: 64px;\n      object-fit: contain;\n   }\n\n   .actions {\n      background-color: #fcfcfc;\n      border: 1px solid #e5e5e5;\n      margin: 5px 0;\n      padding: 40px 0 40px 0;\n   }\n\n   .menu-button{\n      padding: 1px 6px 1px 6px;\n   }\n\n   .etax {\n      background-color: #fff;\n      border: 1px solid #e5e5e5;\n      border-radius: 6px;\n      cursor: pointer;\n      font-size: 16px;\n      display: inline-block;\n      margin: 10px auto 10px;\n      padding: 5px 50px;\n      width: 100%;\n   }\n\n   .company {\n      border-bottom: 2px solid #2AB4C0;\n      font-size: 22px;\n      line-height: normal;\n      width: 100%;\n      margin: 5px 0;\n   }\n\n   .space {\n      width: 100%;\n      background-color: #d4f0f2;\n      color: #007c9e;\n      float: right;\n      padding: 10px 15px 15px;\n      margin-top: 10px;\n   }\n\n   .money-chart {\n      padding: 25px 20px ;\n      position: relative;\n      width: 100%;\n      height: 340px;\n      overflow: hidden;\n      text-align: center;\n   }\n\n   .card {\n      background: #fff;\n      box-shadow: 0 1px 4px rgba(0,0,0,.1);\n      padding: 10px;\n   }\n\n   .type-chart {\n      padding: 10px 30px 20px;\n      position: relative;\n      width: 100%;\n      height: 100%;\n      overflow: hidden;\n   }\n\n   .usage-chart {\n      position: relative;\n      width: 100%;\n   }\n}\n\n.status:hover {\n   background-color: rgba(0,0,0,.05);\n   color: #000;\n   text-decoration: none;\n}\n\n.status .counter {\n   font-size: 36px;\n}\n\n.actions button {\n   border: 1px solid #2AB4C0;\n   background-color: #fff;\n}\n.actions button + button {\n   margin-left: 2em;\n}\n.actions img, .actions svg {\n   height: 20px;\n   margin-right: 8px;\n   width: 20px;\n}\n.actions img, .actions span {\n   display: inline-block;\n   vertical-align: middle;\n}\n.sign-now-button{\n   margin-left: 10px!important;\n}\n\n.box+.box {\n   margin-top: 30px;\n}\n\n.etax img {\n   display: block;\n   height: 75px;\n   width: 80px;\n   margin: 10px auto;\n   user-select: none;\n}\n.quota {\n   background-color: rgba(255,255,255,.5);\n   margin-top: 8px;\n   width: 300px;\n}\n.used {\n   background-color: #2AB4C0;\n   width: 0;\n   height: 10px;\n   transition: width 1s ease-in;\n}\n.usage {\n   font-size: 12px;\n}\n\n.activities {\n   min-height: 300px;\n   padding: 10px 0 0 10px;\n   position: relative;\n   width: 800px;\n}\nh3 {\n   margin: 10px;\n   text-align: center;\n}\n#money {\n   margin-bottom: 30px;\n}\n.money-chart .buy-button {\n   background-color: #fff;\n   border: 1px solid #2ab4c0;\n   /*border-radius: 4px;*/\n   /*cursor: pointer;*/\n   /*display: inline-block;*/\n   /*line-height: 36px;*/\n   padding: 0 5px;\n   width: 125px;\n   /*user-select: none;*/\n}\n.money-chart button.sell {\n   background-color: #fff;\n   border: 1px solid #ffa726;\n   width: 125px;\n   padding: 0 5px;\n}\n.money-chart button + button {\n   margin-left: 2em;\n}\n#usage {\n   height: 386px;\n}\n.doclist {\n   list-style: none;\n   margin: 9px 0 0;\n   padding: 0;\n}\n.doclist li {\n   border-top: 1px solid transparent;\n   margin-top: -1px;\n   padding: 8px;\n   position: relative;\n}\n.doclist li:not(:last-child) {\n   border-bottom: 1px solid #eaeaea;\n}\n.avatar {\n   border-radius: 50%;\n   margin-right: 10px;\n   object-fit: contain;\n   width: 32px;\n   height: 32px;\n}\n.name {\n   color: #222;\n}\n.time {\n   color: #999;\n   font-size: 12px;\n}\n.list-activity {\n   max-height: 300px;\n   overflow-x: hidden;\n   overflow-y: auto;\n}\nhr {\n   border: 0;\n   border-top: 1px solid #ccc;\n   margin: 20px 0;\n}\ntd {\n   text-align: left;\n   padding: 5px\n}\ntd div {\n   overflow-wrap: break-word;\n   width: 250px;\n}\n.sum {\n   font-size: 28px;\n   margin-bottom: 10px;\n}\n.buy {\n   color: #2ab4c0;\n}\n.sell {\n   color: #ffa726;\n}\n.amount {\n   width: 100%;\n}\n.amount td:first-child, .amount td:nth-child(2) {\n   text-align: right;\n   white-space: nowrap;\n}\n.amount td:nth-child(2) {\n   width: 30%;\n}\n.center {\n   text-align: center;\n}\n\n.grid-container-columns {\n   display: grid;\n   grid-row-gap: 0px;\n   grid-template-columns: auto auto auto;\n   /*background-color: #2196F3;*/\n   /*padding: 10px;*/\n}\n\n.grid-container-rows{\n   display: grid;\n   grid-row-gap: 0px;\n   grid-template-rows: auto auto auto;\n}\n\n.grid-item {\n   /*background-color: rgba(255, 255, 255, 0.8);*/\n   /*border: 1px solid rgba(0, 0, 0, 0.8);*/\n   /*padding: 20px;*/\n   /*font-size: 30px;*/\n   /*text-align: center;*/\n}\n/*::ng-deep cdk-global-scrollblock {*/\n   /*overflow-y: hidden!important;*/\n/*}*/\n.max-space{\n   font-size:14px!important;\n   margin-left: 110px;\n   margin-bottom: 10px;\n}\n.link{\n   cursor: default!important;\n   font-size:10px;\n   pointer-events: none;\n   text-align: right;\n   width: 90px;\n}\n.progress-bar{\n   height:18px;\n   border-radius: 15px;\n   width:330px;\n   pointer-events: none;\n}\n.progress-form{\n   width:50%;\n   margin-left: 15px;\n   margin-right: 10px;\n   padding: 20px 20px 10px 20px!important;\n}\n.type-name{\n   width:80px;\n}\n.button-form{\n   width:50% !important;\n}\n::ng-deep .mat-progress-bar-buffer {\n   background: #E4E8EB!important;\n}\n.space-left{\n   width:230px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
